var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsCircleci = function SvgMillustrationsCircleci(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "M27.777 13c-3.261 0-5.998 2.239-6.768 5.266a.3.3 0 0 0-.009.068c0 .183.149.333.333.333h2.816c.134 0 .248-.08.301-.195a3.66 3.66 0 0 1 3.327-2.139c2.02 0 3.66 1.642 3.66 3.667a3.664 3.664 0 0 1-3.66 3.667 3.66 3.66 0 0 1-3.326-2.14v.001a.33.33 0 0 0-.303-.194h-2.815a.333.333 0 0 0-.325.4C21.778 24.76 24.515 27 27.777 27c3.858 0 6.986-3.134 6.986-7s-3.128-7-6.986-7m-1.664 7c0-.92.745-1.666 1.664-1.666S29.44 19.08 29.44 20s-.745 1.667-1.663 1.667A1.665 1.665 0 0 1 26.113 20",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsCircleci;